import { Box, Container, SvgIcon, TextField, Typography } from "@mui/material";
import { Formik } from "formik";
import * as Yup from "yup";
import { Label } from "../common/Label/Label";
import { CustomTextField } from "../common/CustomTextField/CustomTextField";
import { Button } from "../common/Button/Button";
import {
  PageSetupHolder,
  PageSetup,
  LinkHolder,
  TrialSetupPage,
  LeftSide,
  RightSide,
} from "./style";
import axios from "axios";
import { BrightHiveLogo } from "./BrightHiveLogo";
import { formatLabel } from "../helpers";
import { useState } from "react";
import { toast } from "react-toastify";
import { NavbarWrapper } from "../common/Navbar/style";
import { EnvelopeIcon } from "@heroicons/react/24/outline";
import { ReactComponent as brighthiveImage1 } from "../assets/brighthive-theme/brighthiveImage1.svg";
import { BrighthiveIcon } from "../common/Icons/BrighthiveIcon";
import { placeholder } from "@uiw/react-codemirror";

const AUTH_TOKEN = process.env.REACT_APP_SETUP_AUTH_TOKEN;
const SETUP_URL = process.env.REACT_APP_SETUP_URL;

export const SetupPage = () => {
  const [success, setSuccess] = useState(false);
  const [isSubmitting, setSubmitting] = useState(false);

  return (
    <PageSetupHolder className="dark">
      <NavbarWrapper
        className="NavbarWrapper"
        role="banner"
        sx={{
          backgroundColor: "transparent",
          padding: "20px 10px",
        }}
      >
        <BrightHiveLogo />
        <SvgIcon
          className="brighthive-image"
          component={brighthiveImage1}
          viewBox="0 0 1444 314"
        />
      </NavbarWrapper>
      <TrialSetupPage>
        <LeftSide>
          <Formik
            validationSchema={Yup.object().shape({
              firstName: Yup.string().required("First Name is required"),
              lastName: Yup.string().required("Last Name is required"),
              companyEmail: Yup.string()
                .email("Please Provide a Valid Business Email")
                .required("Email is required")
                .test(
                  "not-common-domains",
                  "Gmail, Hotmail, Outlook and Yahoo addresses are not allowed",
                  (value: any) => {
                    if (!value) return true; // let required handle empty
                    const forbiddenDomains = [
                      "gmail.com",
                      "hotmail.com",
                      "yahoo.com",
                      "outlook",
                    ];
                    const domain = value.split("@")[1]?.toLowerCase();
                    return domain && !forbiddenDomains.includes(domain);
                  }
                ),
              companyName: Yup.string().required("Company Name is required"),
              CompanyWebsite: Yup.string()
                .url("Company Website is required")
                .required("Company Website is required"),
            })}
            initialValues={{
              firstName: "",
              lastName: "",
              companyEmail: "",
              companyName: "",
              CompanyWebsite: "",
            }}
            onSubmit={async (values) => {
              setSubmitting(true);
              axios
                .post(
                  `${SETUP_URL}/adminapi/userapi/createuser`,
                  {
                    org_name: values.companyName,
                    domain: values.CompanyWebsite,
                    given_name: values.firstName,
                    family_name: values.lastName,
                    email: values.companyEmail,
                    is_trial: true,
                  },
                  {
                    headers: {
                      Authorization: `Bearer ${AUTH_TOKEN}`,
                    },
                  }
                )
                .then((res) => {
                  setSuccess(true);
                  console.log(res);
                })
                .catch((err) => {
                  console.log(err);
                  const msg =
                    err?.response.data?.error?.message?.value || err?.message;
                  toast.error(msg);
                })
                .finally(() => setSubmitting(false));
            }}
          >
            {({
              values,
              handleChange,
              handleBlur,
              setFieldValue,
              handleSubmit,
              errors,
              touched,
              isValid,
            }) => {
              return (
                <>
                  {!success ? (
                    <Box className="trial-setup-form">
                      <Box
                        className="brighthive-logo"
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          margin: "0 auto 20px",
                          color: "link.main",

                          svg: {
                            width: "40px",
                            height: "40px",
                          },
                        }}
                      >
                        <BrighthiveIcon className="logo-icon" />
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          margin: "20px 0 0",
                        }}
                      >
                        <Typography
                          variant="h6"
                          fontWeight={600}
                          textAlign={"center"}
                          color={"common.black"}
                        >
                          Start Your Free Trial
                        </Typography>
                        <Typography
                          variant="body3"
                          textAlign={"center"}
                          color={"gray.dark"}
                        >
                          Join thousands of companies transforming their data
                          workflow
                        </Typography>
                      </Box>
                      <br />
                      <form onSubmit={handleSubmit}>
                        {[
                          { name: "firstName", placeholder: "i.e. John" },
                          { name: "lastName", placeholder: "i.e. Doe" },
                          {
                            name: "companyEmail",
                            placeholder: "i.e. example@mycompany.com",
                          },
                          {
                            name: "companyName",
                            placeholder: "i.e. My Company",
                          },
                          {
                            name: "CompanyWebsite",
                            placeholder: "i.e. https://mycompany.com",
                          },
                        ].map((item) => (
                          <Box key={item.name} mt={5}>
                            <Label
                              mb={1}
                              width={"15.5rem"}
                              value={
                                <>
                                  {formatLabel(item.name)}{" "}
                                  <span style={{ color: "rgb(199, 20, 41)" }}>
                                    *
                                  </span>
                                </>
                              }
                            />
                            <CustomTextField
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={(values as any)?.[`${item}`]}
                              error={(errors as any)?.[`${item}`]}
                              touched={(touched as any)?.[`${item}`]}
                              placeholder={item.placeholder}
                              name={item.name}
                              fullWidth
                              inputProps={{
                                sx: {
                                  fontSize: "1rem",
                                  padding: ".375rem .75rem",
                                },
                              }}
                              size="small"
                            />
                          </Box>
                        ))}

                        <Box
                          className="trial-setup-form-footer"
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            margin: "20px 0",
                            gap: "10px",
                          }}
                        >
                          <Button
                            variant="contained"
                            type="submit"
                            className="btn"
                            disabled={
                              isSubmitting || !values.firstName || !isValid
                            }
                            sx={{
                              width: "100%",
                              height: "50px !important",
                              padding: "15px !important",
                              fontSize: "1rem !important",
                              fontWeight: "600 !important",
                              borderRadius: "0.375rem !important",
                            }}
                          >
                            Start Free Trial
                          </Button>
                          <Typography
                            variant="body3"
                            textAlign={"center"}
                            color={"gray.dark"}
                          >
                            No credit card required • 07-day free trial
                          </Typography>
                        </Box>
                      </form>
                    </Box>
                  ) : (
                    <Box
                      className="trial-setup-form"
                      color={"gray.dark"}
                      textAlign={"center"}
                    >
                      <Box
                        sx={{
                          width: "64px",
                          height: "64px",
                          backgroundColor: "rgb(201 242 234 / 0.5)",
                          borderRadius: "50%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          margin: "0 auto 20px",
                          color: "primary.dark",
                        }}
                      >
                        <EnvelopeIcon width={32} height={32} />
                      </Box>
                      <Typography
                        variant="h6"
                        fontWeight={600}
                        textAlign={"center"}
                        color={"common.black"}
                      >
                        One More Step: Verify Your Email
                      </Typography>
                      <br />
                      <Typography variant="body3">
                        Thank you for signing up for your free trial! We've sent
                        a verification email to{" "}
                        <Typography
                          variant="body3"
                          component={"span"}
                          fontWeight={500}
                          color={"common.black"}
                        >
                          {values.companyEmail}
                        </Typography>
                        . To continue, please check your inbox and click the
                        verification link in the email we just sent.
                        <br />
                        <br /> If you don't see the email within a few minutes,
                        please check your spam or junk folder.
                        <br />
                        <LinkHolder
                          sx={{
                            a: {
                              color: "primary.dark",
                              textDecoration: "none",
                              fontWeight: "600",
                              "&:hover": {
                                textDecoration: "underline",
                              },
                            },
                          }}
                        >
                          <a href="mailto:support@brighthive.io">
                            Need help? Contact our Support Team.
                          </a>
                        </LinkHolder>
                      </Typography>
                    </Box>
                  )}
                </>
              );
            }}
          </Formik>
        </LeftSide>
        <RightSide>
          <Box>
            <Typography
              variant="h5"
              fontWeight={600}
              textAlign={"center"}
              color={"common.black"}
            >
              Transform Your Data Into Insights
            </Typography>
            <Typography
              variant="body1"
              textAlign={"center"}
              color={"gray.dark"}
            >
              Join leading companies using Brighthive to unlock the power of
              their data
            </Typography>
          </Box>
          <img src="/homePageImage.png" alt="brighthive" />
        </RightSide>
      </TrialSetupPage>
    </PageSetupHolder>
  );
};
